export var _baseCalendarTheme = {
  baseStyle: _ref => {
    var {
      isMobileDatePicker
    } = _ref;
    return {
      container: {
        width: isMobileDatePicker ? '100%' : 'fit-content',
        display: 'flex',
        flexDir: 'column',
        color: 'neutral.black',
        gridGap: 's'
      },
      header: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDir: 'row',
        alignItems: 'center',
        paddingY: isMobileDatePicker ? 'xs' : 'none',
        "&[data-hidden='true']": {
          visibility: 'hidden'
        }
      },
      monthContainer: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: isMobileDatePicker ? 'xs' : 'none',
        "&[data-hidden='true']": {
          visibility: 'hidden'
        }
      },
      calendar: {
        display: 'grid',
        width: isMobileDatePicker ? '100%' : 'fit-content',
        _disabled: {
          pointerEvents: 'none',
          opacity: 0.5
        }
      },
      calendarRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)'
      },
      headerCell: {
        width: '40px',
        height: '40px',
        textStyle: 'body4Semi',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textTransform: 'uppercase',
        userSelect: 'none',
        textAlign: 'center'
      },
      cell: {
        width: '36px',
        height: '36px',
        margin: 'xxxs',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textStyle: 'body4Semi',
        border: 'input-thick.transparent',
        borderRadius: 'full',
        cursor: 'pointer',
        color: 'neutral.black',
        '&:hover[aria-selected]:not([aria-selected="true"]):not([aria-disabled="true"])': {
          bgColor: 'neutral.lighter'
        },
        '&[data-secondary-selected-date="true"][aria-selected="false"]': {
          border: 'input-thick.readOnly'
        },
        _selected: {
          color: 'neutral.white',
          bgColor: 'brand.main'
        },
        _focusVisible: {
          outlineColor: 'focus.focus',
          outlineStyle: 'solid',
          outlineWidth: '2px',
          outlineOffset: '2px'
        },
        _disabled: {
          color: 'neutral.light',
          cursor: 'initial'
        }
      },
      todayMarker: {
        height: '8px',
        width: '8px',
        bgColor: 'neutral.black',
        borderRadius: 'full',
        position: 'absolute',
        bottom: 0
      },
      content: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: '100%'
      },
      yearSelectionHeaderTrigger: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexShrink: 0,
        _focusVisible: {
          outlineColor: 'focus.focus',
          outlineOffset: '2px'
        }
      },
      yearSelectionContainer: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: isMobileDatePicker ? 'xs' : 'none',
        position: 'absolute',
        backgroundColor: 'neutral.white',
        zIndex: 'docked',
        inset: 0,
        width: '100%',
        height: '100%',
        paddingTop: isMobileDatePicker ? 'xs' : 'none'
      },
      yearSelectionList: {
        display: 'flex',
        flexDirection: 'column',
        borderTop: 'basic.light',
        overflowY: 'auto',
        height: '100%'
      },
      yearSelectionListItem: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: isMobileDatePicker ? 'xs' : 'none',
        width: '100%',
        borderBottom: 'basic.light'
      },
      yearSelectionListItemTrigger: {
        display: 'flex',
        justifyContent: 'center',
        padding: 's',
        backgroundColor: 'neutral.white',
        textStyle: 'body2Semi',
        color: 'neutral.darker',
        outlineColor: 'focus.focus',
        outlineOffset: '-1px',
        _expanded: {
          backgroundColor: 'neutral.lightest',
          color: 'neutral.black'
        },
        _disabled: {
          pointerEvents: 'none',
          color: 'neutral.light'
        },
        _hover: {
          backgroundColor: 'neutral.lightest',
          color: 'neutral.darkest',
          transition: 'color 0.1s, background-color 0.1s',
          _expanded: {
            backgroundColor: 'neutral.lightest'
          }
        },
        _active: {
          backgroundColor: 'neutral.lighter',
          _expanded: {
            backgroundColor: 'neutral.lightest',
            color: 'neutral.black'
          }
        }
      },
      monthSelectionGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        gap: 'xs',
        padding: 's',
        paddingTop: 'none',
        backgroundColor: 'neutral.lightest'
      },
      monthSelectionCell: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        minWidth: '88px',
        padding: 'xs',
        borderRadius: 'l',
        textStyle: 'body4Semi',
        outlineColor: 'focus.focus',
        _hover: {
          bgColor: 'neutral.lighter'
        },
        _active: {
          color: 'brand.main'
        },
        _disabled: {
          pointerEvents: 'none',
          color: 'neutral.light'
        }
      }
    };
  },
  sizes: {
    small: _ref2 => {
      var {
        isMobileDatePicker
      } = _ref2;
      return {
        calendar: {
          rowGap: isMobileDatePicker ? 'xs' : 'none'
        },
        calendarRow: {
          columnGap: isMobileDatePicker ? 'xs' : 'none'
        }
      };
    },
    large: _ref3 => {
      var {
        isMobileDatePicker
      } = _ref3;
      return {
        calendar: {
          rowGap: isMobileDatePicker ? 'xs' : 'xxxs'
        },
        calendarRow: {
          columnGap: 'xxs'
        }
      };
    }
  },
  defaultProps: {
    size: 'large'
  }
};
//# sourceMappingURL=_BaseCalendar.theme.js.map